import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import vehiclesReducer from './slices/vehiclesSlice'
import alertsReducer from './slices/alertsSlice'
import circuitsReducer from './slices/circuitsSlice'
import demoReducer from './slices/demoSlice'
import parentReducer from './slices/parentSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    vehicles: vehiclesReducer,
    alerts: alertsReducer,
    circuits: circuitsReducer,
    demo: demoReducer,
    parent: parentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
